export enum SuggestType {
    UNKNOWN = 0,
    NEW_BUILDING = 1,
    DEVELOPER = 2,
    BANK = 3,
    GEO = 4,
}
